import {
  defaultTransitionClass,
  nToPx,
  themeVars,
  toBorder,
} from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const cardWrapperClass = style({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: themeVars.radius.md,
  backgroundColor: themeVars.colors.neutrals.white,
  boxShadow: themeVars.shadow.elevationLight,
  overflow: 'hidden',
  gap: themeVars.space.x4,
  marginBottom: themeVars.space.x6,
  selectors: {
    '&:last-child': {
      marginBottom: 0,
    },
  },
});

export const cardContainerClass = style([
  defaultTransitionClass,
  {
    padding: themeVars.space.x5,
    width: '100%',
    display: 'flex',
    gap: themeVars.space.x2,
  },
]);

export const withSideBorderClass = style({
  border: toBorder({
    width: 1,
    color: themeVars.colors.brand.primary.x30,
  }),
  borderLeft: toBorder({
    width: 8,
    color: themeVars.colors.brand.primary.x30,
  }),
});

export const cardImageWrapperClass = style({
  flex: 0,
  marginRight: themeVars.space.x4,
});

export const cardContentClass = style({
  width: '100%',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  gap: themeVars.space.x4,
});

export const cardTitleClass = style({
  display: 'flex',
  alignItems: 'center',
  fontSize: themeVars.font.size.textMd,
  fontWeight: themeVars.font.weight.bold,
  color: themeVars.colors.brand.primary.x100,
});

export const statusChipClass = style({
  marginLeft: themeVars.space.x8,
});

export const cardDataWrapperClass = style({
  width: '100%',
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  gap: nToPx(themeVars.space.x4, themeVars.space.x8),
  flexWrap: 'wrap',
});

export const cardActionsWrapperClass = style({
  display: 'flex',
  flex: 0,
  flexDirection: 'column',
  gap: themeVars.space.x2,
  justifyContent: 'flex-end',
  alignItems: 'center',
});

export const cardItemExtraContentClass = style({
  padding: nToPx(0, themeVars.space.x4, themeVars.space.x4),
});
